module.exports = __webpack_public_path__ + "img/qr-code_big.1333443e.png";